import React from "react";
import { Grid, Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../Layout";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(2),
  },
  rightAligned: {
    textAlign: 'right',
  },
}));

export default function SignIn(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [nums, setNums] = React.useState([]);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - メニュー";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchData();
  }, [auth.state.token]);

  const fetchData = () => {
    request({
      method: "GET",
      url: `/admin/filterhose/information`,
    }).then((result) => {
      setNums(result.data.data.status.keyword);
    });
  };

  return (
    <Layout
      content={
        <Grid>
          <Typography variant="h6" color="primary">
            メニューを選択してください
          </Typography>

          <Box mt={4}>
            <Typography variant="h6" color="primary">
              FHキーワード
            </Typography>
            <Grid container className={classes.wrapper}>
              <Grid item xs={1}>
                <Typography>契約数：</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography className={classes.rightAligned}>{nums.num_words != null ? nums.num_words.toLocaleString() : ''} 件</Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.wrapper}>
              <Grid item xs={1}>
                <Typography>TF使用数：</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography className={classes.rightAligned}>{nums.num_tf != null ? nums.num_tf.toLocaleString() : ''} 件</Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.wrapper}>
              <Grid item xs={1}>
                <Typography>BF予約数：</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography className={classes.rightAligned}>{nums.num_bf != null ? nums.num_bf.toLocaleString() : ''} 件</Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.wrapper}>
              <Grid item xs={1}>
                <Typography>残KW数：</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography className={classes.rightAligned}>{nums.num_remain != null ? nums.num_remain.toLocaleString() : ''} 件</Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.wrapper}>
              <Grid item xs={1}>
                <Typography>実使用数：</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography className={classes.rightAligned}>{nums.num_real != null ? nums.num_real.toLocaleString() : ''} 件</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.rightAligned}>※重複KWを除く</Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      }
    />
  );
}
